import { ComponentType } from 'react';

import { ErrorDefinition } from './FormField';


const errors = {
    required: () =>
        'Заполните поле',
    email: () =>
        'Введите email',
    alphanumeric: () =>
        'Допустимы только буквенно-цифровые символы на латинице',
    cyralphanumeric: () =>
        'Допустимы только буквенно-цифровые символы',
    surnameNameMiddlename: () =>
        'Неверный формат имени',
    sample: () =>
        'Значения не совпадают',
    nospace: () =>
        'Значение не должно содержать символов пробела',
    min: ({ min }: { min: number }) =>
        `Длина не должна быть меньше ${min} символов`,
    max: ({ max }: { max: number }) =>
        `Длина не должна превышать ${max} символов`,
    nummin: ({ min }: { min: number }) =>
        `Значение не должно быть меньше ${min}`,
    nummax: ({ max }: { max: number }) =>
        `Значение не должно превышать ${max}`,
    integer: () =>
        'Значение должно быть целым числом',
    finite: () =>
        'Значение должно быть числом',
    specSymbols: () =>
        'Должен быть, как минимум, один из спец. символов ?!@%#',
    upperCase: () =>
        'Должна быть, как минимум, одна заглавная буква',
    digital: () =>
        'Должна быть, как минимум, одна цифра',
};


export type ErrorRendererProps = { error: ErrorDefinition };

export const errorRenderer: ComponentType<ErrorRendererProps> =
    ({ error }) => error && errors[error.key](error.values);
